// @ts-check

import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { VisibilityIcon, VisibilityOffIcon } from 'components/icons';
import { func, object, string } from 'prop-types';

/**
 * @component ProfilePwdField
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {string} props.value
 * @param {ValidObjType} props.valid
 * @param {()=>void} props.onChange
 * @returns {JSX.Element}
 */
function ProfilePwdField({ name, label, value, valid, onChange }) {
	const [show, setShow] = useState(false);

	return (
		<TextField
			fullWidth
			variant="outlined"
			InputLabelProps={{ shrink: true }}
			type={show ? 'text' : 'password'}
			required
			name={name}
			label={label}
			value={value}
			error={valid.hasErr}
			helperText={valid.msg}
			onChange={onChange}
			autoComplete="new-password"
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton onClick={() => setShow(!show)}>
							{show ? <VisibilityIcon /> : <VisibilityOffIcon />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
}

ProfilePwdField.propTypes = {
	name: string.isRequired,
	label: string.isRequired,
	value: string.isRequired,
	valid: object.isRequired,
	onChange: func.isRequired,
};

export default ProfilePwdField;
